<template>
    <div class="cart-course">
        <div class="information">
            <div class="columns is-mobile">
                <div class="column is-narrow is-hidden-touch">
                    <i class="fad fa-browsers has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="course-title">
                        <i class="fad fa-browsers has-text-primary is-hidden-desktop mr-2"></i>
                        {{ course.name }}
                    </div>
                    <div class="custom-name">
                        {{ course.name }}
                        <span v-if="course.custom1">{{ course.custom1 }}</span>
                        <span v-if="course.custom2">{{ course.custom2 }}</span>
                    </div>
                    <div class="course-meta mt-3">
                        <span class="meta-item">
                            <i class="fas fa-clock mr-2"></i>{{ course.hours }} Clock Hours
                        </span>
                        <span class="meta-item ml-4 is-hidden-mobile">
                            <i class="fas fa-calendar-alt mr-2"></i>Expires: {{ course.expiresOn }}
                        </span>
                        <span class="meta-item is-block is-hidden-tablet mt-2">
                            <i class="fas fa-calendar-alt mr-2"></i>Expires: {{ course.expiresOn }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CartCourse",
        props: ['course'],
        data: function() {
            return {
            };
        },
    };
</script>

<style lang="scss" scoped>
    .cart-course {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1.5rem;
        }

        .course-title {
            font-weight: 600;
            color: #1e3a5f;
            font-size: 1rem;
        }

        .custom-name {
            font-weight: normal;
            font-size: 0.8rem;
            color: #737881;
            margin-top: 0.25rem;
        }

        .course-meta {
            color: #666;
            font-size: 0.9rem;

            .meta-item {
                i {
                    color: #336699;
                }
            }
        }
    }
</style>
